export default __webpack_public_path__ + "static/media/globe.361e721d.png";